import { Link } from 'react-router-dom';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';

function NotFound() {
  return (
    <>
      <Seo
        title="Page Not Found"
        description="The page you were looking for could not be found."
      />
      <Header />

      <main
        className="page-content"
        style={{
          minHeight: '55vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '60px 20px',
        }}
      >
        <h1 style={{ color: '#024437', fontSize: '3rem', margin: 0 }}>404</h1>
        <p style={{ fontSize: '1.2rem', maxWidth: '480px' }}>
          Sorry, we couldn&rsquo;t find the page you were looking for.
        </p>
        <Link
          to="/"
          className="hover-lift"
          style={{
            marginTop: '16px',
            backgroundColor: '#024437',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '6px',
            padding: '12px 24px',
            fontSize: '16px',
          }}
        >
          Back to home
        </Link>
      </main>

      <Footer />
    </>
  );
}

export default NotFound;
